
const digest = '9cb5a5a13ce169ac88d54e46416a0102c2c8fc94f595d089e2de0e1c9b4ecaef';
const classes = {"options":"_options_1q14l_1","option":"_option_1q14l_1","active":"_active_1q14l_22"};
const css = `._options_1q14l_1 {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 20px;
}
._options_1q14l_1 ._option_1q14l_1 {
  border: 2px solid #dce7fa;
  width: 100%;
  border-radius: 15px;
  padding: 20px 30px 20px 60px;
  color: #3c3f9c;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  margin: 4px 0;
  text-align: left;
  background-position: left 20px top 17px;
  background-repeat: no-repeat;
  background-image: url("/dist/patientV3/icons/radio-default.svg");
}
._options_1q14l_1 ._option_1q14l_1._active_1q14l_22 {
  border-color: #6549f0;
  background-image: url("/dist/patientV3/icons/radio-selected.svg");
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  